<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->
@if (!partial()) {
  <div class="title-bar">
    <i class="fal fa-calendar-alt"></i>
    @if (canNavigate()) {
      <span class="switch-month" (click)="previousMonth()">
        <span class="fal fa-chevron-left"></span>
      </span>
    }
    @if (view && view.currentDate) {
      <span class="title">{{
        view.currentDate.toDate()
          | date: 'MMMM yyyy' : null : translate.currentLang
      }}</span>
    }
    @if (canNavigate()) {
      <span class="switch-month" (click)="nextMonth()">
        <span class="fal fa-chevron-right"></span>
      </span>
    }
  </div>
}

<table
  class="view-month"
  [class.border]="partial()"
  (mousemove)="onMouseMove($event)"
>
  <thead>
    <tr #header>
      <th>{{ 'calendar.days.mon' | translate }}</th>
      <th>{{ 'calendar.days.tue' | translate }}</th>
      <th>{{ 'calendar.days.wed' | translate }}</th>
      <th>{{ 'calendar.days.thu' | translate }}</th>
      <th>{{ 'calendar.days.fri' | translate }}</th>
      <th>{{ 'calendar.days.sat' | translate }}</th>
      <th>{{ 'calendar.days.sun' | translate }}</th>
    </tr>
  </thead>
  <tbody
    (dragenter)="$event.preventDefault()"
    (dragover)="$event.preventDefault()"
    (dragleave)="onDragLeaveTbody()"
  >
    @for (line of weeks; track line) {
      <tr>
        @for (cell of line; track cell.day) {
          <td
            (dragover)="onDragOver(cell)"
            class="month-cell"
            [style.height.px]="rowHeight()"
            [style.background-color]="cell.backgroundColor"
          >
            <infl-calendar-cell
              #dayCell
              [cell]="cell"
              [enable]="enable()"
              (contextmenu)="onRightClick($event)"
              (mousedown)="selectCell(cell, $event, true)"
              (dblclick)="onCellDblClick($event)"
              (mouseenter)="selectCell(cell, $event, false)"
              (dropTask)="onDropTask(cell)"
              (mouseover)="overZone($event, cell)"
            />
          </td>
        }
      </tr>
    }
  </tbody>
  @for (task of viewTasks; track task.task.id) {
    <div
      class="task"
      [ngClass]="{ enable: enable() }"
      [ngStyle]="task.style"
      [draggable]="canDrag() && task.task.enable"
      (click)="onTaskClick($event, task.task)"
      (dblclick)="onTaskClick($event, task.task, true)"
      (mouseenter)="taskHover.emit(task.task)"
      (mouseleave)="taskHover.emit(null)"
      (dragstart)="onDragStart(task, $event)"
    >
      @if (enable() && canResize() && task.task.enable) {
        <div
          class="resize"
          (mousedown)="startResize($event, task.task, 'left')"
        >
          <span class="fal fa-ellipsis-v"></span>
        </div>
      }
      <div
        class="background"
        [ngStyle]="{
          'background-color':
            task.task.backgroundColor.length === 9
              ? task.task.backgroundColor
              : task.task.backgroundColor + 'BF',
        }"
      >
        <div class="text">
          @if (task.task.icon) {
            <span class="icon fal fa-{{ task.task.icon }}"></span>
          }
          {{ task.task.label }}
        </div>
      </div>

      @if (enable()) {
        <div class="remove">
          <span class="fal fa-times"></span>
        </div>
      }

      @if (enable() && canResize() && task.task.enable) {
        <div
          class="resize right"
          (mousedown)="startResize($event, task.task, 'right')"
        >
          <span class="fal fa-ellipsis-v"></span>
        </div>
      }
    </div>
  }
</table>
